import React, { useState, useCallback, useMemo } from 'react'
import { GameButton } from '@fedsim/components'
import { DeleteAll } from 'icons'

const Variants = {
    text: "text",
    outlined: "outlined",
    contained: "contained"
} as const;
type VariantsEnum = typeof Variants[keyof typeof Variants];

const Sizes = {
  small: "small",
  medium: "medium",
  large: "large"
} as const;
type SizesEnum = typeof Sizes[keyof typeof Sizes];

const Colors = {
  inherit: "inherit",
  primary: "primary",
  secondary: "secondary",
  error: "error",
  info: "info",
  success: "success",
  warning: "warning"
} as const;
type ColorsEnum = typeof Colors[keyof typeof Colors];

type ConfirmButtonTypes = {
    Icon?: React.FC,
    label?: string,
    onClick?: () => void,
    confirmLabel?: string,
    variant?: VariantsEnum,
    color?: ColorsEnum,
    size?: SizesEnum,
}

function ConfirmButton({
    Icon = DeleteAll,
    label = 'Label',
    onClick = () => { },
    confirmLabel = 'Are you sure?',
    variant = Variants.contained,
    color = Colors.error,
    size = Sizes.small,
}: ConfirmButtonTypes): JSX.Element {
    const [confirmDelete, setConfirmDelete] = useState(false)
    const title = useMemo(() => confirmDelete ? confirmLabel : label, [confirmDelete, confirmLabel, label])
    const clickHandler = useCallback(() => {
        if (confirmDelete) {
            onClick()
            setConfirmDelete(false)
        } else {
            setConfirmDelete(true)
            setTimeout(() => {
                setConfirmDelete(false)
            }, 5000)
        }
    }, [confirmDelete, onClick])

    return (
        <GameButton
            onClick={clickHandler}
            variant={variant}
            color={color}
            size={size}>
            <Icon /> {title}
        </GameButton>
    )
}

export default ConfirmButton
